import React from 'react';
import Project from '../../components/project/Project';
import { YFA, project02, project03, Amora, project05 } from './imports';
import './work.css';

const Work = () => (
  <div className="gpt3__blog section__padding" id="blog">
    <div className="gpt3__blog-heading">
      <h1 className="gradient__text">Innovations in Action: <br /> Our Recent Projects</h1>
    </div>
    <div className="gpt3__blog-container">
      <div className="gpt3__blog-container_groupA">
        <Project
            imgUrl={YFA} date="Aug 02, 2024"
            text="Youth Farmers Association is a digital stokvel platform helping young farmers collaborate, pool funds, and access resources. Members save collectively for seeds, tools, and projects while sharing knowledge and bulk-buying discounts. The mobile-friendly system tracks contributions, manages shared assets, and connects farmers to grants and markets—turning individual efforts into community growth."
            link="https://yfa.onrender.com/"
        />
      </div>
      <div className="gpt3__blog-container_groupB">
        <Project imgUrl={project02} date="July 18, 2024" text="Creatives SA migrates to Python Server Managed by Maidport to strengthen security." link="https://www.creativessa.com/" />
        <Project
            imgUrl={project03}
            date="May 26, 2024"
            text="We developed a user-friendly app that helps you easily store, organize, and redeem coupons."
            link="https://couponkeep-f009d.web.app/" />
        <Project
            imgUrl={Amora} date="Sept 18, 2024"
             text="Amora is an all-in-one business management platform designed to empower small and growing SMME teams by streamlining operations, payroll, and customer engagement. With powerful automation and intuitive tools, Amora helps businesses save time, reduce errors, and scale efficiently—accessible anytime on web and mobile."
            link="https://amora-u6nf.onrender.com/" />
        <Project imgUrl={project05} date="Aug 29, 2024" text="Meerath Publishers transitioned their site to WordPress to overcome limitations of their previous platform. We facilitated this migration, enabling greater customization and functionality." link="https://meerathpublishers.co.za/" />
      </div>
    </div>
  </div>
);

export default Work;
